var Backbone = require('backbone');
var _ = require('underscore');

require('./Login.less');


module.exports = Backbone.View.extend({

    el: '.Login',

    events: {
        'click .Login-buttonLogin': 'onLoginClick',
        'click .Login-buttonCreate': 'onCreateClick',
        'click .Login-inputForgot': 'onForgotClick',
        'input .Login-input': 'onLoginInputChange',
        'keydown .Login-input': 'onLoginInputKeyDown'
    },


    initialize: function () {
        _.bindAll(this, 'onLoginInputChange');

    },


    show: function (params) {
        this.$el.addClass('visible');

        this.$el.toggleClass('Login--new', !!params.isNew);
        this.$el.toggleClass('Login--common', !params.isNew);

        if (params.isNew) {
            this.$('.Login-input[name="email"]').val(''); //reset email and password from first screen login (if any)
            this.$('.Login-input[name="password"]').val('');
        }

        if (params.email) {
            this.$('.Login-input[name="email"]').val(params.email);
            this.$('.Login-input[name="password"]').focus();
        } else {
            this.$('.Login-input[name="email"]').focus();
        }

        //check auto filled inputs by browser
        setTimeout(this.onLoginInputChange, 0);
        setTimeout(this.onLoginInputChange, 100);
        setTimeout(this.onLoginInputChange, 300);
        setTimeout(this.onLoginInputChange, 500);
        setTimeout(this.onLoginInputChange, 1000);
    },


    hide: function () {
        this.$el.removeClass('visible');
    },


    onForgotClick: function () {
        this.trigger('forgot-email', this.$('.Login-input[name="email"]').val());
    },


    onLoginClick: function () {
        var $emailInput = this.$('.Login-input[name="email"]');
        var $passwordInput = this.$('.Login-input[name="password"]');
        var $button = this.$('.Login-buttonLogin');

        $button.addClass('Button--loading');

        this._xhr && this._xhr.abort();

        this._xhr = $.ajax(Urls['submissions:api:login']('json'), {
            method: 'POST',
            contentType: 'application/json; charset=utf-8',
            dataType: 'json',
            data: JSON.stringify({
                'email': $emailInput.val(),
                'password': $passwordInput.val()
            }),
            success: function (data) {
                $button.removeClass('Button--loading');

                window.location.href = Urls['submissions:submissions']();
            }.bind(this),
            error: function (e, tp) {
                $button.removeClass('Button--loading');

                if (tp != 'abort') {
                    if (e.status == 400) { //bad request
                        alert('Error: ' + e.responseText);
                    } else if (e.status == 403) { //forbidden
                        $button.flashClass('Button--shake', 500);
                        //alert('Not Authorized');
                    } else {
                        alert('Error ' + e.status + ': ' + e.statusText);
                    }
                }

                console.log('error', arguments);
            }.bind(this)
        });
    },


    onLoginInputKeyDown: function (e) {
        var $emailInput = this.$('.Login-input[name="email"]');
        var $passwordInput = this.$('.Login-input[name="password"]');

        if (e.keyCode == 13) {
            if ($(e.currentTarget).is($emailInput)) {
                if ($emailInput.val() && $passwordInput.val()) {
                    this.onLoginClick();
                } else {
                    $passwordInput.focus();
                }
            }

            if ($(e.currentTarget).is($passwordInput)) {
                this.onLoginClick();
            }

            e.preventDefault();
        }
    },


    onLoginInputChange: function (e) {
        var $emailInput = this.$('.Login-input[name="email"]');
        var $passwordInput = this.$('.Login-input[name="password"]');
        var $button = this.$('.Login-buttonLogin');
        var isValid = $emailInput.val() && $passwordInput.val();

        $button.toggleClass('Login-buttonLogin--active', !!isValid);
    }
});



//////////////////
// WEBPACK FOOTER
// ./assets/app/submissions/components/Login/Login.js
// module id = 107
// module chunks = 0